import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { KineticText } from "./Motion";
import { IMAGES } from "../data";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "18%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1.25]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.55, 0.85]);

  return (
    <section id="hero" ref={ref} className="relative h-[100svh] w-full overflow-hidden" data-testid="hero-section">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Football stadium under floodlights"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <motion.div style={{ opacity: overlayOpacity }} className="absolute inset-0 bg-black" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/40" />

      <div className="relative z-10 h-full max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-20 md:pb-28">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 1 }}
          className="flex items-center gap-4 mb-8"
        >
          <span className="w-12 h-px bg-[#5cc6ff]" />
          <span className="font-outfit text-xs uppercase tracking-[0.35em] text-[#5cc6ff]">
            Football Photographer · Est. 2023
          </span>
        </motion.div>

        <h1 className="font-anton uppercase leading-[0.82] text-white text-[16vw] md:text-[13vw] lg:text-[11rem]">
          <KineticText lines={["TMB"]} delay={0.5} testid="hero-line-1" />
          <KineticText
            lines={["Fotografia"]}
            delay={0.7}
            className="text-[#5cc6ff]"
            testid="hero-line-2"
          />
        </h1>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mt-10">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.9 }}
            className="font-manrope text-base md:text-lg text-white/70 max-w-md"
          >
            Raw Action. Captured in Real Time
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.6, duration: 1 }}
            className="flex items-center gap-3 text-white/50"
          >
            <motion.span
              animate={{ y: [0, 8, 0] }}
              transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
            >
              <ArrowDown strokeWidth={1.5} size={20} className="text-[#5cc6ff]" />
            </motion.span>
            <span className="font-outfit text-xs uppercase tracking-[0.25em]">Scroll to enter</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
